import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  paddingBottom: '$6',
  width: '100%',
  backgroundColor: primitive.$white,
  borderRadius: 'xl',
});

export const Title = withTypography({
  variant: 'headerThree',
  fontSize: 'md',
  mb: '$2',
  mt: '$6',
  textAlign: 'center',
});

export const BenefitText = withTypography({
  variant: 'headerThree',
  bold: true,
  fontSize: '6xl',
  mb: '$2',
  textAlign: 'center',
  lineHeight: 82, // 1.375em x 60px (original lineHeight: 'md'),
});

export const ContentText = withTypography({
  variant: 'headerThree',
  fontSize: 'xl',
  color: primitive.$bbqBrown,
  textAlign: 'center',
  m: '$0',
  lineHeight: 28, // 1.4em x 20px,
});

export const InfoContainer = Box.withConfig({
  display: 'flex',
  alignItems: 'center',
  marginTop: '$4',
});

export const InfoBadge = Box.withConfig({
  backgroundColor: primitive.$blueLight,
  height: '$8',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  width: 'fit-content',
  padding: '$2',
});

export const InfoText = withTypography({
  variant: 'headerThree',
  fontSize: 'sm',
  textAlign: 'center',
  color: primitive.$blueWalmart,
  m: '$0',
});

export const SectionTitle = withTypography({
  variant: 'headerThree',
  fontSize: 'xl',
  my: '$6',
  textAlign: 'center',
  lineHeight: 28, // 1.4em x 20px,
});
